export default "__VITE_ASSET__51925ffe__"